w<!-- ==========================================================================================
    File Name: Create.vue
    Description: Create Customers Page
========================================================================================== -->

<template>
        <div id="create-customers-page">
                <vx-card>
                        <!-- Personal Data -->
                        <div class="vx-row leading-loose mt-3">
                                <div class="vx-col w-full md:w-1/2">
                                        <h4>Datos de Mascota</h4>
                                </div>
                        </div>
                        <vs-row vs-w="12">
                                <vs-col
                                        vs-align="center"
                                        vs-justify="center"
                                        vs-lg="2"
                                        vs-sm="12"
                                        vs-type="flex"
                                        vs-xs="12"
                                >
                                        <vs-upload
                                                v-if="petData.owner"
                                                :headers="headers"
                                                action="/api/user/update/pet/photo"
                                                file-name="pet"
                                                limit="1"
                                                :data="{ owner: petData.owner }"
                                                automatic
                                                show-upload-button
                                                text="Subir foto"
                                                text-max="Se han alcanzado el limite de archivos"
                                                @on-success="successUpload"
                                        />
                                </vs-col>
                                <vs-col vs-lg="10" vs-sm="12" vs-xs="12">
                                        <!-- Row -->
                                        <div class="vx-row leading-loose mt-3">
                                                <div class="vx-col w-full md:w-1/3">
                                                        <vs-select
                                                                v-model="petData.owner"
                                                                v-validate="'required'"
                                                                class="w-full select-large"
                                                                label="Dueño de la mascota"
                                                                name="owner"
                                                                no-data="No hay datos que mostrar"
                                                        >
                                                                <vs-select-item
                                                                        v-for="(item, index) in customers"
                                                                        :key="index"
                                                                        :text="
                                                                                `${item.unidad.nombre_bloque} ${item.unidad.nombre_unidad} `
                                                                        "
                                                                        :value="item.id"
                                                                />
                                                        </vs-select>
                                                        <span
                                                                v-show="errors.has('owner')"
                                                                class="text-danger text-sm"
                                                                >{{ errors.first('owner') }}</span
                                                        >
                                                </div>
                                                <div class="vx-col w-full md:w-1/3">
                                                        <vs-input
                                                                v-model="petData.nombre"
                                                                v-validate="'required|alpha_spaces'"
                                                                name="nombre"
                                                                label="Nombre"
                                                                class="w-full no-icon-border"
                                                        />
                                                        <span
                                                                v-show="errors.has('nombre')"
                                                                class="text-danger text-sm"
                                                                >{{ errors.first('nombre') }}</span
                                                        >
                                                </div>
                                                <div class="vx-col w-full md:w-1/3">
                                                        <vs-input
                                                                v-model="petData.raza"
                                                                v-validate="'required|alpha_spaces'"
                                                                name="raza"
                                                                label="Raza"
                                                                class="w-full no-icon-border"
                                                        />
                                                        <span v-show="errors.has('raza')" class="text-danger text-sm">{{
                                                                errors.first('raza')
                                                        }}</span>
                                                </div>
                                        </div>
                                        <!-- end row -->
                                        <!-- Row -->
                                        <div class="vx-row leading-loose mt-3">
                                                <div class="vx-col w-full md:w-1/2">
                                                        <vs-input
                                                                v-model="petData.color"
                                                                v-validate="'required|alpha_spaces'"
                                                                name="color"
                                                                label="Color"
                                                                class="w-full no-icon-border"
                                                        />
                                                        <span
                                                                v-show="errors.has('color')"
                                                                class="text-danger text-sm"
                                                                >{{ errors.first('color') }}</span
                                                        >
                                                </div>
                                                <div class="vx-col w-full md:w-1/2">
                                                        <vs-input
                                                                v-model="petData.especie"
                                                                v-validate="'required|alpha_spaces'"
                                                                name="especie"
                                                                label="Especie"
                                                                class="w-full no-icon-border"
                                                        />
                                                        <span
                                                                v-show="errors.has('especie')"
                                                                class="text-danger text-sm"
                                                                >{{ errors.first('especie') }}</span
                                                        >
                                                </div>
                                        </div>
                                        <!-- end row -->
                                </vs-col>
                        </vs-row>

                        <!-- start row -->
                        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-10" vs-w="12">
                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="12">
                                        <vs-button
                                                color="primary"
                                                type="filled"
                                                icon-pack="FA5"
                                                icon="far fa-save"
                                                @click="createPet()"
                                                >Agregar mascota</vs-button
                                        >
                                </vs-col>
                        </vs-row>
                        <!-- end row -->
                        <!-- end Personal Data -->
                </vx-card>
        </div>
</template>

<script>
import { mapState } from 'vuex';
import AwesomeMask from 'awesome-mask';

import { Validator } from 'vee-validate';
const dict = {
        custom: {
                raza: {
                        alpha_spaces: 'En este campo solo se permiten letras y espacios',
                        required: 'Este campo es requerido',
                },
                nombre: {
                        alpha_spaces: 'En este campo solo se permiten letras y espacios',
                        required: 'Este campo es requerido',
                },
                color: {
                        alpha_spaces: 'En este campo solo se permiten letras y espacios',
                        required: 'Este campo es requerido',
                },
                especie: {
                        alpha_spaces: 'En este campo solo se permiten letras y espacios',
                        required: 'Este campo es requerido',
                },
                owner: {
                        required: 'Este campo es requerido',
                },
                photo: {
                        required: 'Este campo es requerido',
                },
        },
};
// register custom messages
Validator.localize('en', dict);

export default {
        data() {
                return {
                        petData: {
                                owner: '',
                                nombre: '',
                                raza: '',
                                color: '',
                                especie: '',
                        },
                        headers: {
                                Authorization: `Bearer ${this.$store.state.authToken}`,
                        },
                };
        },
        computed: {
                ...mapState(['customers']),
                updateOwner: function() {
                        return this.data.owner;
                },
        },
        methods: {
                successUpload() {
                        this.$vs.notify({
                                color: 'success',
                                title: 'Imagen actualizada',
                                text: '',
                        });
                },
                createPet() {
                        this.$validator.validateAll().then(result => {
                                if (result) {
                                        this.$store
                                                .dispatch('createPet', this.petData)
                                                .then(res => {
                                                        console.log(res);
                                                        this.openAlert('success', res.message);
                                                        this.$router.push({ name: 'listUsers' });
                                                })
                                                .catch(err => console.log(err.message));
                                }
                        });
                },
                openAlert(color, message) {
                        this.colorAlert = color || this.getColorRandom();
                        this.$vs.dialog({
                                color: this.colorAlert,
                                title: 'Aviso',
                                text:
                                        this.colorAlert === 'danger'
                                                ? ' Ocurrio un error, por favor contacta al administrador'
                                                : message,
                                accept: this.acceptAlert,
                        });
                },
                acceptAlert() {
                        this.$vs.notify({
                                color: this.colorAlert,
                                title: 'Aviso',
                                text:
                                        this.colorAlert === 'danger'
                                                ? ' Por favor revisa todos los campos'
                                                : 'Continuemos',
                        });
                },
        },
        components: {},
};
</script>
